/**
 * Setup a basic accordion class
 */
class Accordion {
  constructor(accordion) {
    this.accordion = accordion;
    this.toggles   = this.accordion.querySelectorAll('.toggle');
  }

  run() {
    this.initToggles();
  }

  initToggles() {
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'false') {
          this.openItem(toggle);
        } else {
          this.closeOpenItem();
        }
      });
    });
  }

  openItem(toggle) {
    this.closeOpenItem();

    const item    = toggle.parentNode;
    const content = item.querySelector('.content');

    item.classList.add('expanded');
    content.style.maxHeight = `${content.scrollHeight + 20}px`;
    toggle.setAttribute('aria-expanded', 'true');
  }

  closeOpenItem() {
    const open = this.accordion.querySelector('.expanded');

    if (open) {
      open.classList.remove('expanded');
      open.querySelector('.toggle').setAttribute('aria-expanded', 'false');
      open.querySelector('.content').style.maxHeight = null;
    }
  }
}

const accordions = document.querySelectorAll('.accordion');

accordions.forEach((accordion) => {
  const AccordionInstance = new Accordion(accordion);

  AccordionInstance.run();
});
